import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SkipStopRecurringComponent } from 'src/app/shared/cart/skip-stop-recurring/skip-stop-recurring.component';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vacation',
  templateUrl: './vacation.component.html',
  styleUrls: ['./vacation.component.scss']
})
export class VacationComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['startDate', 'endDate', 'comments', 'action'];
  vacationDates = [];
  dataSource = new MatTableDataSource([]);
  contentLoaded = false;
  featureTags = {};
  private vacationUpdateSubscription: Subscription;

  constructor(
    private apiService: ApiService, 
    private dialog : MatDialog,
    public sharedDataService: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.featureTags = JSON.parse(
      sessionStorage.getItem("featureTags")
    );
    this.getRecurring();
    this.vacationUpdateSubscription = this.sharedDataService.vacationUpdate$.subscribe(data => {
      if(data){
        this.getRecurring();
      }
    });
  }

  ngOnDestroy() {
    if (this.vacationUpdateSubscription) {
      this.vacationUpdateSubscription.unsubscribe();
    }
  }

  getRecurring() {
    this.apiService.getRecurring().subscribe(result => {
      if (!!this.featureTags && this.featureTags['ftag_sf_vacation_dates_for_no_recurring']) {
        if(result['response']['status'] === 1) {
          this.vacationDates = result['response']['data']['vacation_dates'];
          this.dataSource = new MatTableDataSource(this.vacationDates);
        }else if(result['response']['status'] === 6){
          if(result['response']['data']['vacation_dates'] && result['response']['data']['vacation_dates'].length > 0){
            this.vacationDates = result['response']['data']['vacation_dates'];
            this.dataSource = new MatTableDataSource(this.vacationDates);
          }else{
            this.vacationDates = [];
          }
        }
      }else{
        if(result['response']['status'] === 1) {
          this.vacationDates = result['response']['data']['vacation_dates'];
          this.dataSource = new MatTableDataSource(this.vacationDates);
        }
      }

      this.contentLoaded = true;
    } , error =>{
      this.contentLoaded = true;
    });
  }
  addVacationDates(event) {
    const dialogRef = this.dialog.open(SkipStopRecurringComponent, {
      width : '450px',
      data : { value : 'add vacation dates'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(!!result && result['status'] === 1) {
      } else if(!!result && result === 'close') {
      }
      event.target.blur();
    });
  }
  editVacation(value, event: Event | null = null) {
    const dialogRef = this.dialog.open(SkipStopRecurringComponent, {
      width : '450px',
      data : { value : 'edit vacation dates', data: value}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(!!result && result['status'] === 1) {
      }
    
      if (event && event.target instanceof HTMLElement) {
        event.target.blur();
      } 
    });
  }

  deleteVacation(value, event: Event | null = null) {
    const dialogRef = this.dialog.open(SkipStopRecurringComponent, {
      width : '450px',
      data : { value : 'delete vacation dates' , data: value}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(!!result && result['status'] === 1) {
        this.getRecurring();  
      }
      if (event && event.target instanceof HTMLElement) {
        event.target.blur();
      }
    });
  }
}
